export default function getIconName(icon, suggestedWeight = "far") {
  if (!icon) return undefined;

  const arr = icon.split(" ");

  let addWeight = true;

  if (
    arr.includes("far") ||
    arr.includes("fas") ||
    arr.includes("fal") ||
    arr.includes("fad") ||
    arr.includes("fab")
  )
    addWeight = false;

  arr[0] = "fa-" + arr[0];

  return arr.join(" ");
}
